jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };
    
    $('[rel=popover]').popover({
        html: true,
        placement: 'bottom',
        content: function() {
            return $('.savingsDetailsList').html();
            //return $($(this).data('contentwrapper')).html();
        }
    });

    // *************************************************************************************************
    //	Homepage
    // *************************************************************************************************

    // Place Homepage only Javascript inside of IF statement
    if (document.body.classList.contains('home')) {
        var models_slider = new Swiper('.modelRow .swiper-container', {
			speed: 300,
			slidesPerGroup: 4,
			slidesPerView: 4,
			spaceBetween: 55, // This should match the ".swiper-container" left/right padding on tablet+ in the stylesheet (to allow space for the arrows)
			preloadImages: false,
			navigation: {
				nextEl: '.modelRow .swiper-button-next.model',
				prevEl: '.modelRow .swiper-button-prev.model'
			},
			breakpoints: {
				1024: {
					slidesPerGroup: 2,
					slidesPerView: 2
				},
				767: {
					slidesPerGroup: 1,
					slidesPerView: 1
				},
			},
		});

		$('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
			var index = $(this).parent().index()
			if (models_slider && models_slider[index]) {
				models_slider[index].update();
				models_slider[index].navigation.update();
			}
		});

		if ($(window).width() <= 1024) {
			jQuery('#small-selects #modelTab-contents li a').click(function() {
				var title = jQuery(this).data('title');
				jQuery('#modelTab .swap').html(title);
			});
		}

    }

});